import React, {createContext, useContext, useReducer} from 'react'
import {HandsfreeCameraDeviceOverviewReducer} from "../reducer/HandsfreeCameraDeviceOverviewReducer";
import {PermissionsContext} from "../../../permissions/PermissionsContext";
import PermissionAlertBanner from "../../../commonui/PermissionAlertBanner";

export const HandsfreeCameraDeviceOverviewContext = createContext();

const HandsfreeCameraDeviceOverviewContextProvider = (props) => {
    const data = {
        sortPref: {column: "name", direction: "ascending"},
        asmlComponentInformation: {},
        macAddressArray: [],
        loadingOverview: true
    }
    const [viewModel, dispatch] = useReducer(HandsfreeCameraDeviceOverviewReducer, data)
    const {isAuthorised} = useContext(PermissionsContext);

    if (!isAuthorised){
        return (
            <PermissionAlertBanner/>
        );
    }
    return (
        <HandsfreeCameraDeviceOverviewContext.Provider value={{viewModel, dispatch}}>
            {props.children}
        </HandsfreeCameraDeviceOverviewContext.Provider>
    )
}

export default HandsfreeCameraDeviceOverviewContextProvider



// WEBPACK FOOTER //
// ./src/components/devicemanagement/asmldevice/context/HandsfreeCameraDeviceOverviewContext.js